import Misc from './misc';

class headerSearch { 
  constructor() {
    this.mobileMenuLayout = Misc.getMediaQueries()['mobilemenu-layout'];
    this.headerWrapper = document.querySelector('.site-header');
    this.triggerSearch = document.querySelector('.header-search-trigger');
    this.inputSearch = document.querySelector('.input-text-wrapper input');
    this.triggerCloseSearch = document.querySelector('.input-text-wrapper .op-close');
    
    this.toggleSearch = this.toggleSearch.bind(this);
    this.closeSearch = this.closeSearch.bind(this);
    this.handleOnResize = this.handleOnResize.bind(this);

    this.triggerSearch.addEventListener('click', this.toggleSearch);
    window.addEventListener('resize', this.handleOnResize);
  }

  toggleSearch(event) {
    event.preventDefault();
    if (!this.headerWrapper.classList.contains('on-search')) {
      this.openSearch();
    } else {
      this.closeSearch();
    }
  }
  
  openSearch() {
    const lastTransitionElement = document.querySelector('.header-login');
    
    if (Misc.getViewport().width > this.mobileMenuLayout) {

      this.headerWrapper.classList.add('on-search-transition');

      const afterTransition = () => {
        this.headerWrapper.classList.add('on-search');
        this.inputSearch.focus();
        document.querySelector('.site-header--menu').classList.add('on-search-after-transition');
        this.triggerCloseSearch.addEventListener('click', this.closeSearch );
        Misc.getTransitions() && lastTransitionElement.removeEventListener(Misc.getTransitions(), afterTransition);
      }

      Misc.getTransitions() && lastTransitionElement.addEventListener(Misc.getTransitions(), afterTransition);

    } else {
      this.headerWrapper.classList.add('on-search');
    }

    this.triggerCloseSearch.addEventListener('click', this.closeSearch );

  }

  closeSearch(event) {
    event.preventDefault();

    this.headerWrapper.classList.remove('on-search');

    if (Misc.getViewport().width > this.mobileMenuLayout) {
      this.headerWrapper.classList.remove('on-search-transition');
      document.querySelector('.site-header--menu').classList.remove('on-search-after-transition');
    }
    
    this.triggerCloseSearch.removeEventListener('click', this.closeSearch );

  }

  handleOnResize() {
    if (Misc.getViewport().width < this.mobileMenuLayout && this.headerWrapper.classList.contains('on-search')) {
      this.closeSearch();
    }

    if (Misc.getViewport().width > this.mobileMenuLayout && this.headerWrapper.classList.contains('on-search')) {
      this.closeSearch();
    }
  }
}


new headerSearch();